module.exports = __webpack_public_path__ + "img/industry.7e7c949.svg";